// extracted by mini-css-extract-plugin
module.exports = {"defaultGrid":"styles_defaultGrid__u59j0","desktopGrid":"styles_desktopGrid__ptht_","combinedColumns":"styles_combinedColumns__I9DZq","desktopColumn":"styles_desktopColumn__RBEPo"};